import React from 'react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const problems = ['Llegás al aula sin una estructura clara… improvisando sobre la marcha', 'Niños desordenados, distraídos o sin atención constante', 'Gritás más de lo que te gustaría para mantener el control', 'Pierdes horas planificando… y aun así sientes que no es suficiente'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-233">
      <div className="max-w-xl mx-auto" data-id="element-234">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-235">
          😩 ¿Estás viviendo esto...?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-236">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-237">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-238">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-239">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-240">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-241">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-242">
            ¿Cuánto tiempo más vas a seguir enseñando así?
          </h3>
          <CTAButton text="👉 QUIERO MI AULA SIN ESTRÉS" className="w-auto mx-auto whitespace-nowrap" data-id="element-243" />
        </div>
      </div>
    </section>;
}